import { useState } from 'react';
import { useContent } from '../hooks/useContent';
import styles from './News.module.css';

import img10_04 from '../assets/news/10-04.jpg';
import img10_06 from '../assets/news/10-06.jpg';
import img19_02 from '../assets/news/19-02.png';
import img17_12 from '../assets/news/17-12.jpg';
import img26_02 from '../assets/news/26-02.jpg';
import img27_01 from '../assets/news/27-01.jpg';
import img24_16 from '../assets/news/24-16.jpg';
import img18_02 from '../assets/news/18-02.jpg';
import img19_05 from '../assets/news/19-05.jpg';
import img22_05 from '../assets/news/22-05.jpg';
const TAG_COLORS = {
  'Главное':    { bg: 'rgba(0,198,167,0.15)', border: 'rgba(0,198,167,0.4)', color: '#00c6a7' },
  'Негізгі':    { bg: 'rgba(0,198,167,0.15)', border: 'rgba(0,198,167,0.4)', color: '#00c6a7' },
  'ГОНС':      { bg: 'rgba(0,104,180,0.15)', border: 'rgba(0,104,180,0.4)', color: '#4da8da' },
  'МББЖ':      { bg: 'rgba(0,104,180,0.15)', border: 'rgba(0,104,180,0.4)', color: '#4da8da' },
  'Дошкольное':{ bg: 'rgba(148,103,189,0.15)', border: 'rgba(148,103,189,0.4)', color: '#b48ee0' },
  'Мектепке дейінгі':{ bg: 'rgba(148,103,189,0.15)', border: 'rgba(148,103,189,0.4)', color: '#b48ee0' },
  'Стратегия': { bg: 'rgba(255,193,7,0.12)',  border: 'rgba(255,193,7,0.35)', color: '#ffc107' },
  'ОВПО':      { bg: 'rgba(255,107,53,0.12)', border: 'rgba(255,107,53,0.35)', color: '#ff7a50' },
  'ЖОКББ':      { bg: 'rgba(255,107,53,0.12)', border: 'rgba(255,107,53,0.35)', color: '#ff7a50' },
};

const NEWS_IMAGES_MAP = {
  '10-04': img10_04,
  '10-06': img10_06,
  '19-02': img19_02,
  '17-12': img17_12,
  '26-02': img26_02,
  '27-01': img27_01,
  '24-16': img24_16,
  '18-02': img18_02,
  '19-05': img19_05,
  '22-05': img22_05,
};

const VISIBLE = 3;
const ALL_NEWS_LINK = 'https://fincenter.kz/about/press-releases';

function getNewsImage(key) {
  return key ? NEWS_IMAGES_MAP[key] || null : null;
}

function getCardImageStyle(img) {
  if (!img) return undefined;
  return {
    backgroundImage: `linear-gradient(135deg, rgba(0, 40, 90, 0.65) 0%, rgba(0, 104, 180, 0.35) 55%, rgba(0, 198, 167, 0.15) 100%), url(${img})`,
  };
}

export default function News() {
  const { NEWS, ui } = useContent();
  const nUi = ui.news;
  const common = ui.common;
  const [startIdx, setStartIdx] = useState(0);
  const featured  = NEWS.find(n => n.featured);
  const secondary = NEWS.filter(n => !n.featured);
  const maxStartIdx = Math.max(0, secondary.length - VISIBLE);
  const canPrev = startIdx > 0;
  const canNext = startIdx < maxStartIdx;

  return (
    <section className={styles.section} id="news">
      <div className={styles.bgGlow1} />
      <div className={styles.bgGlow2} />

      <div className={styles.container}>

        {/* ── Header ── */}
        <div className={styles.header}>
          <div className={styles.headerLeft}>
            <span className={styles.badge}>{nUi.badge}</span>
            <h2 className={styles.title}>
              {nUi.title} <span className={styles.accent}>{nUi.titleEm}</span>
            </h2>
          </div>
          <div className={styles.headerRight}>
            <button
              className={styles.navBtn}
              onClick={() => setStartIdx(i => Math.max(0, i - 1))}
              disabled={!canPrev}
              aria-label={common.back}
            >
              <ChevL />
            </button>
            <button
              className={styles.navBtn}
              onClick={() => setStartIdx(i => Math.min(maxStartIdx, i + 1))}
              disabled={!canNext}
              aria-label={common.forward}
            >
              <ChevR />
            </button>
            <a
              
              target="_blank"
              rel="noreferrer"
              className={styles.allLink}
            >
              {nUi.allNews}
              <svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.5">
                <path d="M5 12h14M12 5l7 7-7 7" />
              </svg>
            </a>
          </div>
        </div>

        {/* ── Featured card (large) + side cards ── */}
        <div className={styles.layout}>

          {/* Featured */}
          {featured && (
            <a
              
              target="_blank"
              rel="noreferrer"
              className={`${styles.card} ${styles.cardFeatured}`}
            >
              <div className={styles.cardImg} style={getCardImageStyle(getNewsImage(featured.image))}>
                <div className={styles.imgPattern} />
                <Tag tag={featured.tag} />
              </div>
              <div className={styles.cardBody}>
                <div className={styles.cardDate}>{featured.date}</div>
                <h3 className={styles.cardTitle}>{featured.title}</h3>
                <p className={styles.cardExcerpt}>{featured.excerpt}</p>
                <span className={styles.readMore}>{nUi.readArticle}</span>
              </div>
            </a>
          )}

          {/* Secondary cards (scrollable) */}
          <div className={styles.sideList}>
            {secondary.slice(startIdx, startIdx + VISIBLE).map((n, i) => (
              <a
                key={n.title}
                
                target="_blank"
                rel="noreferrer"
                className={styles.sideCard}
              >
                <div className={styles.sideImg} style={getCardImageStyle(getNewsImage(n.image))}>
                  <div className={styles.imgPattern} />
                  <Tag tag={n.tag} />
                </div>
                <div className={styles.sideBody}>
                  <div className={styles.cardDate}>{n.date}</div>
                  <h3 className={styles.sideTitle}>{n.title}</h3>
                  <p className={styles.sideExcerpt}>{n.excerpt}</p>
                  <span className={styles.readMore}>{nUi.readShort}</span>
                </div>
              </a>
            ))}
          </div>
        </div>

        {/* ── Pagination dots ── */}
        <div className={styles.dots}>
          {Array.from({ length: maxStartIdx + 1 }).map((_, i) => (
            <button
              key={i}
              className={`${styles.dot} ${startIdx === i ? styles.dotActive : ''}`}
              onClick={() => setStartIdx(i)}
              aria-label={`${nUi.page} ${i + 1}`}
            />
          ))}
        </div>

      </div>
    </section>
  );
}

/* ── Tag badge ── */
function Tag({ tag }) {
  const style = TAG_COLORS[tag] || { bg: 'rgba(255,255,255,0.15)', border: 'rgba(255,255,255,0.3)', color: '#e8edf8' };
  return (
    <span
      className="news-tag-badge"
      style={{
        background: style.bg,
        border: `1px solid ${style.border}`,
        color: style.color,
        padding: '4px 12px',
        borderRadius: 20,
        fontSize: '0.75rem',
        fontWeight: 700,
        letterSpacing: '0.08em',
        textTransform: 'uppercase',
        backdropFilter: 'blur(6px)',
      }}
    >
      {tag}
    </span>
  );
}

function ChevL() {
  return (
    <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.5">
      <path d="M15 18l-6-6 6-6" />
    </svg>
  );
}
function ChevR() {
  return (
    <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.5">
      <path d="M9 6l6 6-6 6" />
    </svg>
  );
}